<template>
  <div class="px-10">
    <v-row>
      <v-col>
        <v-icon medium>
          mdi-bell-ring
        </v-icon>
        <span class="font-16 font-weight-bold mx-2">Notifications</span>
      </v-col>
    </v-row>

    <v-row
      v-if="loading"
      no-gutters
    >
      <v-col>
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-col>
    </v-row>

    <div v-else>
      <v-row v-if="edit">
        <v-col
          v-for="(item,i) in employeeNotifications"
          :key="i"
          cols="4"
        >
          <v-checkbox v-model="item.employee_notification_is_active">
            <template v-slot:label>
              <div>
                {{ item.name }}
              </div>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col
          v-for="(item,i) in employeeNotifications"
          :key="i"
          cols="4"
        >
          <span class="font-weight-medium pr-3">{{ item.name }}:</span>
          <span
            v-if="item.employee_notification_is_active === 1"
            class="font-weight-bold"
            style="color:green"
          >
            YES
          </span>
          <span
            v-else
            class="font-weight-bold"
            style="color:red"
          >
            NO
          </span>
        </v-col>
      </v-row>
    </div>

    <v-card-actions v-if="!isMyProfile">
      <v-spacer />
      <v-btn
        v-if="!edit"
        color="primary"
        @click="editForm"
      >
        Edit
      </v-btn>
      <div v-else>
        <v-btn
          :disabled="progressing"
          text
          @click="edit = false"
        >
          Cancel
        </v-btn>
        <v-btn          
          :loading="progressing"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Update
        </v-btn>
      </div> 
    </v-card-actions>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    props: {
      employeeUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        loading: false,
        progressing: false,
        edit: false,
        employeeNotifications: [],
        notificationTypes: [],
        notifications: [],
      }
    },
    computed: {
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadData()
          }
        },
      },
    },
    methods: {    
      loadData () {
        this.loading = true

        Promise.all([
          this.$api.notificationTypes().list(),
          this.$api.hrisEmployeeNotifications().list(this.employeeUid),
        ])
          .then(([notificationTypes, employeeNotifications]) => {
            this.notificationTypes = notificationTypes.data
            this.notifications = employeeNotifications.data

            notificationTypes.data.map(notificationType => {
              employeeNotifications.data.map(employeeNotification => {
                if (notificationType.id === employeeNotification.notification_type_id) {
                  notificationType.employee_notification_is_active = employeeNotification.is_active
                }
              })
           
              if (!notificationType.employee_notification_is_active) {
                notificationType.employee_notification_is_active = 0
              } 
            })

            this.employeeNotifications = notificationTypes.data

            this.loading = false
          })
      },

      submitForm () {
        this.progressing = true

        this.$api.hrisEmployeeNotifications().update(this.employeeUid, this.prepareFormData())
          .then(response => {
            this.edit = false
            this.loadData()
            this.$snack({
              message: response.data.status,
            })
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
          })
      },
 
      editForm () {
        this.notificationTypes.map(notificationType => {
          this.notifications.map(employeeNotification => {
            if (notificationType.id === employeeNotification.notification_type_id) {
              notificationType.employee_notification_is_active = employeeNotification.is_active
            }
          })
           
          if (!notificationType.employee_notification_is_active) {
            notificationType.employee_notification_is_active = 0
          } 
        })

        this.employeeNotifications = this.notificationTypes

        this.edit = true
      },
      prepareFormData () {
        let data = []

        this.employeeNotifications.map(employeeNotification => {
          data.push({ notification_type: employeeNotification.id, is_active: employeeNotification.employee_notification_is_active })
        })
    
        return data
      },
    },
  }
</script>

<style scoped>
.font-16{
  font-size:16px;
}
</style>
